import React, { useEffect, useState } from 'react'
import './customStyles.css'

const NumberRangeComponent = ({ onChange, clear, value = [] }) => {
  const [initialNumber, setInitialNumber] = useState(value[0] || null)
  const [lastNumber, setLastNumber] = useState(value[1] || null)

  useEffect(() => {
    if (clear) {
      setInitialNumber(null)
      setLastNumber(null)
    }
  }, [clear])

  const handleInitialChange = (e) => {
    const value = parseInt(e.target.value, 10)
    setInitialNumber(isNaN(value) ? null : value)
    onChange([isNaN(value) ? null : value, lastNumber])
  }

  const handleLastChange = (e) => {
    const value = parseInt(e.target.value, 10)
    setLastNumber(isNaN(value) ? null : value)
    onChange([initialNumber, isNaN(value) ? null : value])
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <div style={{ marginBottom: '5px' }}>
        <input
          type="number"
          value={initialNumber !== null ? initialNumber : ''}
          onChange={handleInitialChange}
          className="input-field"
          placeholder="from"
          style={{
            height: '22px',
            borderRadius: '3px',
            borderColor: '#C0C0C0',
            color: 'gray',
          }}
        />
      </div>
      <div>
        <input
          type="number"
          style={{
            height: '22px',
            borderRadius: '3px',
            borderColor: '#C0C0C0',
            color: 'gray',
          }}
          value={lastNumber !== null ? lastNumber : ''}
          onChange={handleLastChange}
          placeholder="to"
          className="input-field"
        />
      </div>
    </div>
  )
}

export default NumberRangeComponent
